import React, { FC, useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import moment from 'moment';
import { client } from '../../../../App';
import { GET_AUTOMATED_BAR_CHART } from '../../../../queries/widgets';
import { formatBarChartPeriodLabel, rollingPeriodLabel } from '../../../../utils/formatBarChartPeriodLabel';

type Props = {
  isin: string;
  color: string;
  automationType?: string;
};

export const AutomatedBarChart: FC<Props> = ({ isin, automationType, color }) => {
  const [periodsData, setPeriodsData] = useState<any[]>([[]]);
  const [periodLabels, setPeriodLabels] = useState<string[]>();

  const fetchBarChart = async () =>
    client.query({
      query: GET_AUTOMATED_BAR_CHART,
      variables: { isin, type: automationType },
    });

  useEffect(() => {
    fetchBarChart().then((result) => {
      const data = result.data.getAutomatedBarChart;

      const labelRows = [...data].sort(
        (a: any, b: any) =>
          moment(a.end, 'DD.MM.YYYY', true).valueOf() -
          moment(b.end, 'DD.MM.YYYY', true).valueOf(),
      );

      setPeriodLabels(labelRows.map((item: any) => rollingPeriodLabel(item)));
      setPeriodsData([{ name: '', data: labelRows.map((item: any) => item.value) }]);
    });
  }, []);

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 350,
    },
    legend: {
      show: false,
      showForSingleSeries: true,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: 'bottom',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 0,
      colors: ['#fe0f31'],
    },
    tooltip: {
      enabled: true,
      followCursor: true,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return `
      <div class="custom-tooltip" style="border-color: ${color};">
        ${series[seriesIndex][dataPointIndex]?.toFixed(2)}%
      </div>
    `;
      },
    },
    xaxis: {
      categories: periodLabels,
      labels: {
        rotate: 0,
        hideOverlappingLabels: false,
        minHeight: 76,
        offsetY: 4,
        formatter: (val: string) => formatBarChartPeriodLabel(String(val ?? '')),
      },
    },
    yaxis: {
      title: {
        text: 'in %',
        style: {
          fontWeight: 500,
        },
      },
      labels: {
        formatter: function (val) {
          return '';
        },
      },
    },
    fill: {
      opacity: 1,
    },
    colors: [color],
  };

  return (
    <>
      <ReactApexChart
        type="bar"
        height={350}
        options={options}
        series={periodsData}
      />
    </>
  );
};
